var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoPeople = function SvgTwoPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#two-people_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "M1.5 91.5c0-18.778 15.222-34 34-34s34 15.222 34 34v.5c0 6.351-5.149 11.5-11.5 11.5H13c-6.351 0-11.5-5.149-11.5-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B4EF8",
    d: "M107.001 77.653V77c0-13.807-11.193-25-25-25-10.13 0-18.851 6.024-22.78 14.684L56.695 65c4.494-9.46 14.136-16 25.306-16 15.464 0 28 12.536 28 28v.653c0 5.715-4.633 10.347-10.347 10.347H70l-.5-3h30.153A7.347 7.347 0 0 0 107 77.653"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 34.5,
    r: 16,
    stroke: "#7B4EF8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 30,
    r: 12.5,
    stroke: "#7B4EF8",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "two-people_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v120H0z"
  })))));
};
export default SvgTwoPeople;